import _toConsumableArray from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { PureComponent } from 'react';
import { range as getRange } from '../utils/numbers';
import { datepickerClass } from './styles';
import Icon from './Icon';
import { getLocale } from '../locale';
import utils from './utils';
import paramUtils from './paramUtils';
import { isArray } from '../utils/is';
var MONTHBASE = '2019-01-01 00:00:00';

var Year =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Year, _PureComponent);

  var _super = _createSuper2(Year);

  function Year(props) {
    var _this;

    _classCallCheck(this, Year);

    _this = _super.call(this, props);
    _this.handlePrevRange = void 0;
    _this.handleNextRange = void 0;
    _this.handlePrevRange = _this.handleRangeChange.bind(_assertThisInitialized(_this), -15);
    _this.handleNextRange = _this.handleRangeChange.bind(_assertThisInitialized(_this), 15);
    _this.renderYear = _this.renderYear.bind(_assertThisInitialized(_this));
    _this.handleDisabled = _this.handleDisabled.bind(_assertThisInitialized(_this));
    props.disabledRegister(_this.handleDisabled, 'year', props.index);
    return _this;
  }

  _createClass(Year, [{
    key: "getOptions",
    value: function getOptions() {
      var timeZone = this.props.timeZone;
      return {
        timeZone: timeZone,
        weekStartsOn: getLocale('startOfWeek')
      };
    }
  }, {
    key: "handleChange",
    value: function handleChange(year) {
      var _this$props = this.props,
          current = _this$props.current,
          onChange = _this$props.onChange,
          onModeChange = _this$props.onModeChange,
          type = _this$props.type;
      var date = utils.changeDate(current, 'year', year, this.getOptions());
      var isYearType = this.props.type === 'year';
      onChange.apply(void 0, _toConsumableArray(paramUtils.yearHandleChangeParams(date, isYearType, isYearType)));
      if (isYearType) return;
      var nextMode = 'month';

      if (type === 'quarter') {
        nextMode = type;
      }

      onModeChange(nextMode);
    }
  }, {
    key: "handleRangeChange",
    value: function handleRangeChange(year) {
      var _this$props2 = this.props,
          current = _this$props2.current,
          onChange = _this$props2.onChange;
      onChange.apply(void 0, _toConsumableArray(paramUtils.yearHandleChangeParams(utils.addYears(current, year, this.getOptions()))));
    }
  }, {
    key: "handleDisabled",
    value: function handleDisabled(date) {
      var _this$props3 = this.props,
          min = _this$props3.min,
          disabled = _this$props3.disabled,
          range = _this$props3.range,
          type = _this$props3.type,
          index = _this$props3.index,
          rangeDate = _this$props3.rangeDate,
          max = _this$props3.max;
      var isDisabled = min && utils.compareYear(min, date, 1, this.getOptions()) >= 0;

      if (!isDisabled) {
        isDisabled = max && utils.compareYear(date, max, 1, this.getOptions()) >= 0;
      }

      if (!isDisabled && type === 'year' && typeof disabled === 'function') {
        isDisabled = disabled(date);
      }

      if (!isDisabled && index === 1 && isArray(rangeDate)) {
        if (rangeDate[0] && utils.compareAsc(date, utils.addSeconds(rangeDate[0], range, this.getOptions())) > 0) {
          isDisabled = true;
        }
      }

      return isDisabled;
    }
  }, {
    key: "renderYear",
    value: function renderYear(y) {
      var value = this.props.value;
      var date = utils.changeDate(utils.toDate(MONTHBASE, this.getOptions()), 'year', y, this.getOptions());
      var isDisabled = this.handleDisabled(date);
      var className = datepickerClass(value && utils.getDateInfo(value, 'year', this.getOptions()) === y && 'active', isDisabled && 'disabled');
      return (
        /*#__PURE__*/
        React.createElement("span", {
          key: y,
          className: className,
          onClick: isDisabled ? undefined : this.handleChange.bind(this, y)
        }, y)
      );
    }
  }, {
    key: "render",
    value: function render() {
      var current = this.props.current;
      var cy = utils.getDateInfo(current, 'year', this.getOptions()) - 7;
      var years = getRange(15, 0).map(function (i) {
        return cy + i;
      });
      return (
        /*#__PURE__*/
        React.createElement("div", {
          className: datepickerClass('year-picker')
        },
        /*#__PURE__*/
        React.createElement("div", {
          className: datepickerClass('header')
        },
        /*#__PURE__*/
        React.createElement(Icon, {
          name: "AngleLeft",
          className: "left",
          onClick: this.handlePrevRange
        }),
        /*#__PURE__*/
        React.createElement("span", {
          className: datepickerClass('ym')
        }, "".concat(years[0], " ~ ").concat(years[years.length - 1])),
        /*#__PURE__*/
        React.createElement(Icon, {
          name: "AngleRight",
          className: "right",
          onClick: this.handleNextRange
        })),
        /*#__PURE__*/
        React.createElement("div", {
          className: datepickerClass('list')
        }, years.map(this.renderYear)))
      );
    }
  }]);

  return Year;
}(PureComponent);

export default Year;